import * as React from "react";
import {
  Alert,
  Button,
  Form,
  FormField,
  FormInput,
  Flex,
  Provider,
  Text,
} from "@fluentui/react-northstar";
import { useState, useEffect } from "react";
import { useTeams } from "msteams-react-base-component";
import { authentication, dialog } from "@microsoft/teams-js";
import { LogoComponent, MSLogoComponent, InfoComponent } from "./common/logo";
import { EyeIcon, EyeSlashIcon } from "@fluentui/react-icons-northstar";
import { LoaderExample } from "./common/loader";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { saveLoginInformation } from "../action/actionCreators";
import { useHistory } from "react-router-dom";
import * as authService from "../services/auth.service";
import { useTranslation } from "react-i18next";
import { Config } from "../../server-config";

export const LoginComponent = () => {
  const initialLoginState = {
    username: "",
    password: "",
  };

  const [{ inTeams, theme }] = useTeams();
  const [formLogin, setLogin] = useState(initialLoginState);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [alert, showAlert] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(true);
  const dispatch = useDispatch();
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const handleLoginState = (event) => {
    const { name, value } = event.target;
    setLogin({ ...formLogin, [name]: value });
  };

  const dismissAlerts = () => {
    showAlert(false);
  };

  useEffect(() => {
    const multiTextValues = _.values(formLogin);
    const data = multiTextValues.filter((item) => item);
    data.length === 2 ? setDisable(false) : setDisable(true);
  }, [formLogin]);

  const togglePasswordVisible = () => {
    setPasswordVisible(!passwordVisible);
  };

  // useEffect(() => {
  //   var token = localStorage.getItem("appToken");
  //   if (!token) {
  //     var id = document.getElementById("app");
  //     id !== null
  //       ? (id.className = "align-center")
  //       : "";
  //   }
  // }, []);

  const login = () => {
    setDisable(true);
    setLoading(true);
    authService
      .login(formLogin.username, formLogin.password)
      .then((response) => {
        if (response.data.messages && response.data.messages.length > 0) {
          if (response.data.messages[0].code.toLowerCase() === "success") {
            window.localStorage.setItem(
              "appToken",
              response.data.messages[0].text
            );
            window.localStorage.setItem("lang", response.data.messages[0].name);
            if (window.location.href.includes("botlogin")) {
              // window.localStorage.setItem("appToken", params.token);
              if (window.location.href.includes("botlogin")) {
                dialog.url.submit({
                  token: response.data.messages[0].text,
                  locUrl: window.location.href,
                  host: localStorage.getItem("host"),
                  context: localStorage.getItem("context"),
                  appCode: localStorage.getItem("appcode"),
                }, Config.MICROSOFT_APP_ID());
              }
            } else {
              authentication.notifySuccess(
                JSON.stringify({
                  token: response.data.messages[0].text,
                  locUrl: window.location.href,
                  host: localStorage.getItem("host"),
                  context: localStorage.getItem("context"),
                  appCode: localStorage.getItem("appcode")
                })
              );
            }
          } else {
            // Show error message
            // response.data.messages[0].text
            showAlert(!alert);
            setLoading(false);
          }
        }
      });
  };

  return (
    <Provider theme={theme} className="loginProvider" onClick={dismissAlerts}>
      <Flex fill={true} className="appCodeWrapper" column={true}>
        {loading && <LoaderExample />}
        {alert && (
          <Alert
            danger
            content={t("Login.ErrorRequired")}
            onVisibleChange={() => {
              showAlert(!alert);
            }}
            dismissible
            visible={alert}
            dismissAction={{
              "aria-label": "close",
            }}
            className="logonAlert"
          />
        )}
        <Flex.Item align="center">
          <LogoComponent />
        </Flex.Item>
        <Flex.Item>
          <Form className="appForm">
            <FormField>
              <Text
                className="bit_text_24 bit_text_bold loginHeader"
                content={t("Login.Login")}
              />
              <FormInput
                placeholder={t("Login.Username")}
                name="username"
                id="username"
                fluid
                onChange={handleLoginState}
                className={`${"biw_input"}`}
                styles={{ backgroundColor: "#ffffff" }}
                autoFocus
              />
            </FormField>
            <FormField className="passwordField">
              <FormInput
                type={!passwordVisible ? "text" : "password"}
                placeholder={t("Login.Password")}
                name="password"
                id="password"
                fluid
                onChange={handleLoginState}
                className={`${"biw_input"}`}
                styles={{ backgroundColor: "#ffffff" }}
              />
              <span className="showPassword" onClick={togglePasswordVisible}>
                {passwordVisible ? <EyeSlashIcon /> : <EyeIcon />}
              </span>
            </FormField>
            <Button
              fluid={true}
              onClick={login}
              primary
              disabled={disable ? true : false}
            >
              {t("Login.Login")}
            </Button>
          </Form>
        </Flex.Item>
        <Flex.Item>
          <InfoComponent content={t("Login.ContactAdministrator")} />
        </Flex.Item>
      </Flex>
    </Provider>
  );
};
